import React from 'react';
import {
  FDLabelText,
  FDListItem, FDListItemAvatar, FDListItemText, FDLozenge, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

const ActivityRow = ({ memberActivitySummaryResource }) => {
  const handleViewDetails = (/* relationship */) => {
    // TODO: Implement when flyout is added
  };

  const profileImageSrc = memberActivitySummaryResource.withRelationship(
    fr.relationships.profileImage.name,
    (rel) => rel.link('related').url(),
    () => '',
  );

  return (
    <FDStack direction={'row'} alignItems={'center'} spacing={2} paddingY={1} paddingX={1}>
      <FDListItem>
        <FDListItemAvatar alt={memberActivitySummaryResource.attr('owner').toUpperCase()} src={profileImageSrc} />
        <FDListItemText primaryText={memberActivitySummaryResource.attr('title')} secondaryText={memberActivitySummaryResource.attr('subtitle')} />
      </FDListItem>
      <FDLabelText value={memberActivitySummaryResource.attr('createdDate')} />
      <FDLozenge label={memberActivitySummaryResource.attr('statusPrompt')} color={memberActivitySummaryResource.attr('status')} />
      {memberActivitySummaryResource.withRelationship(fr.relationships.details.name,
        (rel) => <FDSecondaryActionButton label={rel.meta('prompt')} onClick={() => handleViewDetails(rel)} size={'sm'} />,
        () => null)}
      {/* TODO: Delete below button */}
      <FDSecondaryActionButton label={'View'} onClick={() => handleViewDetails()} size={'sm'} />
    </FDStack>
  );
};

ActivityRow.defaultProps = {};

ActivityRow.propTypes = {
  memberActivitySummaryResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { ActivityRow };
